import React, { useState, useEffect } from "react";
import { Modal, Button, Row, Col, Form, Card, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import "../../public/MemberForm.css";
import districtData from "../../../assets/districts.json";
import {
  createMemberApi,
  apiPost,
  apiGet,
  createAdminMemberApi,
  canEditMemberFullProfile,
} from "../../../Services";

function AdminCreateMember() {
  const states = [
    "Andaman and Nicobar",
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chandigarh",
    "Chhattisgarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Ladakh",
    "Lakshadweep",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Puducherry",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ];
  const [districts, setDistricts] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    dob: "",
    profession: "",
    country: "India",
    state: "",
    district: "",
    block: "",
    pin: "",
    aadhaar_no: "",
    mobile_no: "",
    vehicle_no: "",
    email: "",
    photo: null,
    aadhaarCard: null,
    registration_id: "",
    member_since: null,
    expiry_date: null,
  });
  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
    setErrors({ ...errors, [name]: "" });
  };

  // Handle state change → update districts
  const handleStateChange = (e) => {
    const selectedState = e.target.value;
    // setFormData({ state: selectedState, district: "", block: "" });
    setFormData((prev) => ({
      ...prev,
      state: selectedState,
      district: "",
      block: "",
    }));

    const filteredDistricts = districtData.districts.filter(
      (d) => d.state === selectedState
    );
    setDistricts(filteredDistricts);
    setBlocks([]);
  };

  // Handle district change → load blocks JSON dynamically
  const handleDistrictChange = async (e) => {
    const selectedDistrict = e.target.value;
    setFormData((prev) => ({
      ...prev,
      district: selectedDistrict,
      block: "",
    }));

    if (!formData.state) return;

    try {
      // Dynamically import the JSON file for blocks
      const blocksFile = await import(
        `../../../assets/BlocksList/${formData.state.replace(/\s/g, "")}.json`
      );

      const districtBlocks = blocksFile[selectedDistrict] || [];
      setBlocks(districtBlocks);
    } catch (error) {
      console.error("Block list not found for this state:", error);
      setBlocks([]);
    }
  };

  const validate = () => {
    let newErrors = {};
    if (formData.registration_id?.trim()) {
      if (!/^MAF-[A-Z]{1,2}-\d+\/\d+$/.test(formData.registration_id.trim())) {
        newErrors.registration_id =
          "Registration ID must be in format: MAF-XX-123/45 (e.g., MAF-WB-101/25)";
      }
    }
    if (!formData.name?.trim()) newErrors.name = "Name is required.";
    if (!formData.dob) newErrors.dob = "Date of Birth is required.";
    if (!formData.profession?.trim())
      newErrors.profession = "Profession is required.";
    if (!formData.state) newErrors.state = "State is required.";
    if (!formData.district) newErrors.district = "District is required.";
    if (!formData.block) newErrors.block = "Block is required.";
    if (!/^[0-9]{6}$/.test(formData.pin))
      newErrors.pin = "Pin Code must be 6 digits.";
    if (!/^[0-9]{12}$/.test(formData.aadhaar_no))
      newErrors.aadhaar_no = "Aadhaar must be 12 digits.";
    if (!/^[0-9]{10}$/.test(formData.mobile_no))
      newErrors.mobile_no = "Mobile number must be 10 digits.";
    if (!formData.photo) newErrors.photo = "Photo is required.";
    if (!formData.aadhaarCard)
      newErrors.aadhaarCard = "Aadhaar card is required.";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.error("Please fix errors before proceeding.");
      return false;
    }
    return true;
  };

  const handleReview = () => {
    if (validate()) {
      setShowModal(true);
    }
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setShowModal(false);

      // const { photo, aadhaarCard, ...dataWithoutFiles } = formData;
      const processedData = {
        ...formData,
        registration_id: formData.registration_id.trim().toUpperCase(),
        name: formData.name.trim().toUpperCase(),
        profession: formData.profession.trim().toUpperCase(),
        vehicle_no: formData.vehicle_no.trim().toUpperCase(),
      };
      const { photo, aadhaarCard, ...dataWithoutFiles } = processedData;

      await createAdminMemberApi(dataWithoutFiles, photo, aadhaarCard);

      toast.success("Member created successfully!");
    } catch (err) {
      const msg = err.response?.data?.error || "Failed to create member";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="container my-4"
      style={{
        fontFamily: "Poppins, sans-serif",
        fontSize: "14px",
        padding: "0 12px",
      }}
    >
      <div className="p-4 border-0 rounded-3 shadow-lg bg-white flex-grow-1">
        {/* <h4 className="mb-5 text-center ">Membership Application Form</h4> */}
        <div className="d-flex flex-column mb-4 text-center align-items-center">
          <h4 className="fw-bold " style={{ color: "#1a5276" }}>
            MemberShip Application Form
            <div
              className="rounded-pill mt-2 bg-warning"
              style={{
                height: "5px",
                width: "15%",
                // backgroundColor: "#EC1F24",
              }}
            ></div>
          </h4>
        </div>
        {loading ? (
          <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ minHeight: "500px" }}
          >
            <Spinner animation="border" variant="primary" />
            <p className="text-muted mt-2">
              Please wait, we are processing your request...
            </p>
            <p className="text-muted mt-2">
              <strong>Please don't close this window.</strong>
            </p>
          </div>
        ) : (
          <Form>
            {canEditMemberFullProfile() &&<Row className="mb-2">
              <Col md={6}>
                <Form.Label className="text-muted">
                  Registration No (optional)
                </Form.Label>
                <Form.Control
                  type="text"
                  name="registration_id"
                  placeholder="Registration No"
                  value={formData.registration_id}
                  onChange={handleChange}
                  isInvalid={!!errors.registration_id}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.registration_id}
                </Form.Control.Feedback>
              </Col>
            </Row> }

            <Row>
              <Col md={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="text-muted">Full Name*</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Max 26 characters allowed"
                    value={formData.name}
                    onChange={handleChange}
                    onBlur={handleChange}
                    isInvalid={!!errors.name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="text-muted">Date of Birth*</Form.Label>
                  <Form.Control
                    type="date"
                    name="dob"
                    value={formData.dob}
                    onChange={handleChange}
                    isInvalid={!!errors.dob}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.dob}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-2">
                  <Form.Control
                    type="text"
                    name="profession"
                    placeholder="Profession*"
                    value={formData.profession}
                    onChange={handleChange}
                    isInvalid={!!errors.profession}
                    autoComplete="off"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.profession}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Select
                  name="state"
                  value={formData.state}
                  onChange={handleStateChange}
                  required
                >
                  <option value="">-- Select State --</option>
                  {states.map((s, idx) => (
                    <option key={idx} value={s}>
                      {s}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.state}
                </Form.Control.Feedback>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Select
                  className="top-margin-sm"
                  name="district"
                  value={formData.district}
                  onChange={handleDistrictChange}
                  required
                  disabled={!formData.state}
                >
                  <option value="">-- Select District --</option>
                  {districts.map((d, idx) => (
                    <option key={idx} value={d.district}>
                      {d.district}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.district}
                </Form.Control.Feedback>
              </Col>
              <Col md={6}>
                <Form.Select
                  className="top-margin-sm"
                  name="block"
                  value={formData.block}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      block: e.target.value,
                    }))
                  }
                  required
                  disabled={!formData.district}
                >
                  <option value="">-- Select Block --</option>
                  {blocks.map((b, idx) => (
                    <option key={idx} value={b}>
                      {b}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.block}
                </Form.Control.Feedback>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={6}>
                <Form.Control
                  type="text"
                  name="pin"
                  placeholder="Pin Code*"
                  value={formData.pin}
                  onChange={handleChange}
                  isInvalid={!!errors.pin}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.pin}
                </Form.Control.Feedback>
              </Col>
              <Col md={6}>
                <Form.Control
                  type="text"
                  name="aadhaar_no"
                  className="top-margin-sm"
                  placeholder="Aadhaar No*"
                  value={formData.aadhaar_no}
                  onChange={handleChange}
                  isInvalid={!!errors.aadhaar_no}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.aadhaar_no}
                </Form.Control.Feedback>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={6}>
                <Form.Control
                  type="text"
                  name="mobile_no"
                  placeholder="WhatsApp Number*"
                  value={formData.mobile_no}
                  onChange={handleChange}
                  isInvalid={!!errors.mobile_no}
                />
                <Form.Text className="text-muted" style={{ fontSize: "11px" }}>
                  This number will be used for all communications.
                </Form.Text>
                <Form.Control.Feedback type="invalid">
                  {errors.mobile_no}
                </Form.Control.Feedback>
              </Col>
              <Col md={6}>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onBlur={handleChange}
                  onChange={handleChange}
                />
                <Form.Text className="text-muted" style={{ fontSize: "11px" }}>
                  Email helps us keep you updated.
                </Form.Text>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={6}>
                <Form.Control
                  type="text"
                  name="vehicle_no"
                  placeholder="Vehicle No"
                  value={formData.vehicle_no}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md={6}>
                <Form.Label className="text-muted">Upload Photo*</Form.Label>
                <Form.Control
                  type="file"
                  name="photo"
                  accept="image/*"
                  onChange={handleChange}
                  isInvalid={!!errors.photo}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.photo}
                </Form.Control.Feedback>
              </Col>
              <Col md={6}>
                <Form.Label className="text-muted">
                  Upload Aadhaar Card*
                </Form.Label>
                <Form.Control
                  type="file"
                  name="aadhaarCard"
                  accept="image/*"
                  onChange={handleChange}
                  isInvalid={!!errors.aadhaarCard}
                />

                <Form.Control.Feedback type="invalid">
                  {errors.aadhaarCard}
                </Form.Control.Feedback>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={6}>
                <Form.Label className="text-muted">Member Since</Form.Label>
                <Form.Control
                  type="date"
                  name="member_since"
                  placeholder="Member Since"
                  value={formData.member_since}
                  onChange={handleChange}
                />
              </Col>
              <Col md={6}>
                <Form.Label className="text-muted">
                  Membership Expiry Date
                </Form.Label>
                <Form.Control
                  type="date"
                  name="expiry_date"
                  placeholder="Membership Expiry Date"
                  value={formData.expiry_date}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            <div className="text-center mt-4">
              <Button variant="primary" onClick={handleReview}>
                Review & Create
              </Button>
            </div>
          </Form>
        )}
      </div>

      {/* Review Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
        className="application-review-modal"
      >
        <Modal.Header closeButton className="modal-header-custom">
          <Modal.Title>
            <i className="bi bi-clipboard-check me-2"></i>
            "Review Your Application"
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="review-progress-bar">
            <div className="progress-step">1. Application</div>
            <div className="progress-step active">2. Review</div>
            <div className="progress-step">3. Payment</div>
          </div>

          <Row className="g-0">
            <Col md={8} className="p-4">
              <div className="section-title fs-5">
                <i className="bi bi-person-badge me-2"></i>
                Personal Information
              </div>

              <Row>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Full Name</label>
                    <p>{formData.name || "Not provided"}</p>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Date of Birth</label>
                    <p>{formData.dob || "Not provided"}</p>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Profession</label>
                    <p>{formData.profession || "Not provided"}</p>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Mobile Number</label>
                    <p>{formData.mobile_no || "Not provided"}</p>
                  </div>
                </Col>
              </Row>

              <div className="data-field">
                <label>Email Address</label>
                <p>{formData.email || "Not provided"}</p>
              </div>

              <div className="section-title mt-4 fs-5">
                <i className="bi bi-geo-alt me-2"></i>
                Address Details
              </div>

              <Row>
                <Col sm={6}>
                  <div className="data-field">
                    <label>State</label>
                    <p>{formData.state || "Not provided"}</p>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="data-field">
                    <label>District</label>
                    <p>{formData.district || "Not provided"}</p>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Block</label>
                    <p>{formData.block || "Not provided"}</p>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="data-field">
                    <label>PIN Code</label>
                    <p>{formData.pin || "Not provided"}</p>
                  </div>
                </Col>
              </Row>

              <div className="section-title mt-4 fs-5">
                <i className="bi bi-card-checklist me-2"></i>
                Identification & Documents
              </div>

              <Row>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Aadhaar Number</label>
                    <p>{formData.aadhaar_no || "Not provided"}</p>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Vehicle Number</label>
                    <p>{formData.vehicle_no || "Not provided"}</p>
                  </div>
                </Col>
              </Row>
            </Col>

            <Col md={4} className="documents-sidebar">
              <div className="p-3">
                <h6 className="text-center mb-3">
                  <i className="bi bi-images me-2"></i>
                  Uploaded Documents
                </h6>

                {formData.photo && (
                  <Card className="mb-3 document-card">
                    <Card.Header className="text-center">
                      Profile Photo
                    </Card.Header>
                    <Card.Body className="text-center p-2">
                      <img
                        src={URL.createObjectURL(formData.photo)}
                        alt="Profile"
                        className="uploaded-image"
                      />
                    </Card.Body>
                  </Card>
                )}

                {formData.aadhaarCard && (
                  <Card className="document-card">
                    <Card.Header className="text-center">
                      Aadhaar Card
                    </Card.Header>
                    <Card.Body className="text-center p-2">
                      <img
                        src={URL.createObjectURL(formData.aadhaarCard)}
                        alt="Aadhaar Card"
                        className="uploaded-image"
                      />
                    </Card.Body>
                  </Card>
                )}

                {!formData.photo && !formData.aadhaarCard && (
                  <div className="text-center text-muted py-4">
                    <i className="bi bi-inbox display-4"></i>
                    <p>No documents uploaded</p>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="modal-footer-custom">
          <Button
            variant="outline-secondary"
            onClick={() => setShowModal(false)}
          >
            <i className="bi bi-arrow-left me-2"></i>
            Back to Edit
          </Button>

          <Button
            variant="success"
            onClick={handleSubmit}
            className="d-flex align-items-center"
          >
            <i className="bi bi-credit-card me-2"></i>
            Create Member
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default AdminCreateMember;
